const e={alignItems:{value:"center"},alignContent:{value:"center"},justifyContent:{value:"flex-start"}};export{e as togglebuttongroup};
